import en from './en';
import ru from './ru';
import ko from './ko';
import hi from './hi';
import ja from './ja';
import fr from './fr';
import ptBR from './pt-BR';
import es from './es';
import id from './id';

import img1 from '@/assets/vpn/feature-1.png';
import img2 from '@/assets/vpn/feature-2.png';
import img3 from '@/assets/vpn/feature-3.png';
import img4 from '@/assets/vpn/feature-4.png';
import img5 from '@/assets/vpn/feature-5.png';
import img6 from '@/assets/vpn/feature-6.png';
import img7 from '@/assets/vpn/feature-7.png';
import img8 from '@/assets/vpn/feature-8.png';

const SITE = 'https://www.vpn-free.com';
const featureImages = [img1, img2, img3, img4, img5, img6, img7, img8];

const localeSources = { ru, ko, hi, ja, fr, 'pt-BR': ptBR, es, id };

/** 路由与 SEO 元信息（TDK 与各 locale 文件一致） */
export const locationLocales = Object.fromEntries(
  Object.entries(localeSources).map(([key, item]) => [
    key,
    {
      label: item.label,
      path: item.path,
      hreflang: item.hreflang,
      htmlLang: item.htmlLang,
      title: item.title,
      description: item.description,
      h1: item.h1,
    },
  ]),
);

const mergeFeatureCards = (cards = []) =>
  cards.map((card, index) => ({
    ...card,
    img: featureImages[index] || featureImages[0],
  }));

/** 组装首页模块所需文案（英文首页返回 null，组件使用内置默认） */
export function getHomeContent(localeKey) {
  const source = localeSources[localeKey];
  if (!source) {
    return null;
  }

  const {
    label,
    path,
    hreflang,
    htmlLang,
    title,
    description,
    h1,
    heroPoints,
    featureCards,
    ...rest
  } = source;

  return {
    localeKey,
    h1,
    heroPoints: (heroPoints || []).map((text) => ({ text })),
    featureCards: mergeFeatureCards(featureCards),
    ...rest,
  };
}

/** 英文首页 + 8 个 location 页的 hreflang */
export function buildHreflangTags() {
  const tags = [{ hreflang: 'en', href: `${SITE}/` }];
  Object.values(locationLocales).forEach((item) => {
    tags.push({ hreflang: item.hreflang, href: `${SITE}${item.path}` });
  });
  tags.push({ hreflang: 'x-default', href: `${SITE}/` });
  return tags;
}

export function getHtmlLangForRoute(meta = {}) {
  if (meta.lang) {
    return meta.lang;
  }
  if (meta.localeKey && locationLocales[meta.localeKey]) {
    return locationLocales[meta.localeKey].htmlLang;
  }
  return 'en';
}

export { en as englishHomeContent };
